import React, { useRef, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveLicencesAction, updateLicencesAction } from '../../../actions/licencesActions';
import { listLicenceTypesAction } from '../../../actions/licenceTypesActions';
import { listUsersAction } from '../../../actions/usersActions';
import { Formik } from 'formik';
import ButtonSpinner from '../../layout/ButtonSpinner';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { ErrorMessage } from '../../extras/toastMessages';
import clienteAxios from '../../../config/axios';
//Función principal
const LicenceForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refJuez = useRef();
    //Datos iniciales
    const initialData = {
        operador: '',
        inicio: '',
        fin: '',
        tipo: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const licencesLoading = useSelector( state => state.licences.loadingSave );
    const errorSave = useSelector( state => state.licences.errorSave );
    const isEdit = useSelector( state => state.licences.isEdit );
    const licenceSelected = useSelector( state => state.licences.licenceSelected );
    //const operators = useSelector( state => state.users.users );
    const licenceTypes = useSelector( state => state.licenceTypes.licenceTypes );
    //Inicializo el state local
    const [ licence, setLicence ] = useState(initialData);
    const [operators, setOperators] = useState(null);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && licenceSelected){
            setLicence({
                ...licenceSelected,
                operador: licenceSelected.operador.id,
                tipo: licenceSelected.tipo.id
            });
        }else{
            setLicence(initialData);
        }
    }, [isEdit, licenceSelected, show])
    //Manejo de cambios
    const handleChange = e => {
        setLicence({
            ...licence,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Armo el objeto de datos
        let data = {
            operador: {
                id: values.operador
            },
            inicio: values.inicio,
            fin: values.fin,
            tipo: {
                id: values.tipo
            },
            activo: 1
        }
        //Verifico si es edición o alta
        if(licence.id){
            //Agrego el id
            data = {
                id: licence.id,
                ...data
            }
            //Es edición
            dispatch( updateLicencesAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveLicencesAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si cargó los jueces
        if(!operators){
            // dispatch( listUsersAction() );
            loadParameters();
        }
        //Me fijo si cargó los tipos
        if(!licenceTypes){
            const paramsTypes = {
                search: 'activo:1',
                sort: 'descripcion:asc'
            }
            dispatch( listLicenceTypesAction(paramsTypes) );
        }
        //Pongo el foco en el primer campo
        refJuez.current.focus();
    }
    //Función para cargar parámetros
    const loadParameters = async () => {
        try{
            //Operadores
            const responseOperators = await clienteAxios.get(`/usuario?search=activo:1,perfil.id:2,nivel.id:3&sort=apellido:asc,nombre:asc`);
            //Seteo los datos
            setOperators(responseOperators.data.content);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Oculto la espera
            // setLoading(false);
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setLicence(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        operador: yup.number().required(),
        inicio: yup.date().required(),
        fin: yup.date().required().min(yup.ref('inicio')),
        tipo: yup.number().required()
    });
    //Renderizo
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Licencia&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...licence }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="juez">Operador/Audiencista</label>
                                    <Form.Control
                                        as="select"
                                        id="operador"
                                        className="form-control"  
                                        name="operador" 
                                        autoFocus 
                                        value={ values.operador }
                                        onChange={handleChange}
                                        isInvalid={!!errors.operador}
                                        disabled={ licencesLoading }
                                        ref={refJuez}
                                    >
                                        <option value="">Seleccione...</option>
                                        {
                                            operators ? (
                                                operators.map(operator => (
                                                    <option value={operator.id} key={`oo${operator.id}`}>
                                                        { `${operator.apellido}, ${operator.nombre}`  }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.operador }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="inicio">Fecha inicio</label>
                                    <Form.Control
                                        id="inicio"
                                        className="form-control" 
                                        name="inicio" 
                                        type="date" 
                                        value={ values.inicio }
                                        onChange={handleChange}
                                        isInvalid={!!errors.inicio}
                                        disabled={ licencesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.inicio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="fin">Fecha fin</label>
                                    <Form.Control
                                        id="fin"
                                        className="form-control" 
                                        name="fin" 
                                        type="date" 
                                        value={ values.fin }
                                        onChange={handleChange}
                                        isInvalid={!!errors.fin}
                                        disabled={ licencesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fin }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="tipo">Tipo</label>
                                    <Form.Control
                                        as="select"
                                        id="tipo"
                                        className="form-control"  
                                        name="tipo" 
                                        autoFocus 
                                        value={ values.tipo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.tipo}
                                        disabled={ licencesLoading }
                                    >
                                        <option value="">Seleccione el Tipo</option>
                                        {
                                            licenceTypes ? (
                                                licenceTypes.map(licenceType => (
                                                    <option value={licenceType.id} key={`it${licenceType.id}`}>
                                                        { licenceType.descripcion  }
                                                    </option>
                                                ))
                                            ) : null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tipo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                licencesLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ licencesLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ licencesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default LicenceForm;